import React, { useState } from 'react'
import { useStateValue } from '@State'
import PropTypes from 'prop-types'
import { LoadingSpinner } from '../../../../components'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const StudentIdRow = ({ selectedStudent, contextStudents, iteration }) => {
  const [currentState] = useStateValue()
  const [myedStudent, setMyedStudent] = useState(selectedStudent)
  const [selectedCanvasId, setSelectedCanvasId] = useState(
    selectedStudent.canvasId
  )
  const [idNeedsSave, setIdNeedsSave] = useState(false)
  const [loading, setLoading] = useState(false)

  const canvasIdDropdown = () => {
    return (
      <React.Fragment>
        <select value={selectedCanvasId} onChange={handleIdChange}>
          <option value="">None</option>
          {contextStudents.map((student, i) => (
            <option
              value={student.id}
              key={i}
            >{`${student.sortable_name} (ID: ${student.id})`}</option>
          ))}
        </select>
        {idNeedsSave ? (
          <a className="ml-3 fs-normal" onClick={updateStudentId}>
            Update
          </a>
        ) : null}
      </React.Fragment>
    )
  }

  const handleIdChange = e => {
    let canvasStudent = contextStudents.find(
      student => `${student.id}` === e.target.value
    )
    if (myedStudent.canvasId !== e.target.value) {
      setIdNeedsSave(true)
    } else {
      setIdNeedsSave(false)
    }

    if (canvasStudent) {
      setSelectedCanvasId(canvasStudent.id)
    } else {
      setSelectedCanvasId('')
    }
  }

  const updateStudentId = () => {
    setLoading(true)
    let params = {
      coursenum: currentState.contextToolsCoursenum,
      studentMyedId: myedStudent.myedId,
    }
    let data = { myedStudentId: myedStudent.myedId, selectedCanvasId }
    client
      .post(endpoints.updateStudentId(params), data)
      .then(resp => {
        console.log(resp)
        setMyedStudent(resp.data)
        setIdNeedsSave(false)
      })
      .catch(err => {
        console.log(err)
        toast.error(err)
      })
    setLoading(false)
  }

  const matchFoundIcon = matchFound => {
    if (matchFound) {
      return (
        <div>
          <i className="fa-solid fa-check text-success myed-success" />
        </div>
      )
    } else {
      return (
        <div>
          <i className="fa-solid fa-exclamation text-warning myed-warning" />
        </div>
      )
    }
  }

  return (
    <React.Fragment>
      <tr className={`${iteration > 0 ? 'border-top' : null}`} height="100px">
        <td>{matchFoundIcon(myedStudent.canvasIdFound)}</td>
        <td>{myedStudent.name}</td>
        <td />
        <td>
          {myedStudent.canvasId ? (
            myedStudent.canvasId
          ) : (
            <div>
              No ID{' '}
              <i className="fa-solid fa-exclamation text-warning myed-warning" />
            </div>
          )}
        </td>
        <td />
        <td>
          {canvasIdDropdown()}
          {loading ? <LoadingSpinner /> : null}
        </td>
      </tr>
    </React.Fragment>
  )
}

export default StudentIdRow

StudentIdRow.propTypes = {
  selectedStudent: PropTypes.object,
  contextStudents: PropTypes.array,
  iteration: PropTypes.integer,
}
